import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { ParametrizarParametrosModel } from './ParametrizarParametros.model';
import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';


@Component({
	selector: 'ParametrizarParametrosIndex',
	templateUrl: './ParametrizarParametrosIndex.component.html',
	styleUrls: ['../../../../styles.css']
})

/**
* @author Camilo
* @since  31/10/2017
**/
export class ParametrizarParametrosIndexComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;

	public ocultar: boolean= false;
	public mensaje: string="";
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public parametros: Array<ParametrizarParametrosModel>;
	public guardando: boolean;

	public displayedColumns = ['Unidades_UVT', 'Valor_UVT', 'Nanno', 'Editar'];
	public dataDataBase: ParametrosDatabase;
	public dataSource: ExampleDataSource;

	@ViewChild('filter') filter: ElementRef;


	constructor(private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog,
		private confirmarEliminacionService: ConfirmarEliminacionService) {
		this.parametros = new Array();
		this.guardando = false;

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
	}


	ngOnInit() {
		this.cargarTabla();
	}


	private cargarTabla() {
		this.dataDataBase = new ParametrosDatabase();

		this._serviciosGenerales.get('parametrosUVT', {}).subscribe(
			result => {
				this.parametros = new Array();
				for (let x of result) {
					let parametrizarParametrosModel: ParametrizarParametrosModel = new ParametrizarParametrosModel(x.NUNIDADESUVT,x.NVALORUVT,x.NANNO);
					this.dataDataBase.addParametro( parametrizarParametrosModel);
				}
				this.dataSource = new ExampleDataSource(this.dataDataBase);
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar configuraciones UVT ", "X");
			}
		);

		Observable.fromEvent(this.filter.nativeElement, 'keyup')
			.debounceTime(150)
			.distinctUntilChanged()
			.subscribe(() => {
				if (!this.dataSource) {
					return;
				}
				this.dataSource.filter = this.filter.nativeElement.value;
			});
	}
	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}
	openSnackBarEspecial(message: string, action: string) {
        let snackBarRef =  this.snackBar.open(message, action);
 
        snackBarRef.onAction().subscribe(() => {
           
            this.ocultar = false;
            this.mensaje = "";
        });
        
        let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;        
        
        if (shand.length != 0) {
                for (let i=0;i<shand.length;i++){
                shand[i].style.backgroundColor = "rgb(255 204 214)";
                }
            }
    }

	editar(parametro:ParametrizarParametrosModel){
		console.log("Entró ", parametro);
		console.log(parametro);
		this._router.navigate(['/ParametrizarParametros', parametro.nanno]);
	}

	agregar() {
		console.log("========================");
		this._router.navigate(['/ParametrizarParametros', '']);
	}

}




// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class ParametrosDatabase {

	dataChange: BehaviorSubject<ParametrizarParametrosModel[]> = new BehaviorSubject<ParametrizarParametrosModel[]>([]);

	get data(): ParametrizarParametrosModel[] {
		return this.dataChange.value;
	}

	addParametro(parametro: ParametrizarParametrosModel) {
		const copiedData = this.data.slice();
		copiedData.push(parametro);
		this.dataChange.next(copiedData);
	}

}


export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string {
		return this._filterChange.value;
	}

	set filter(filter: string) {
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: ParametrosDatabase) {
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	
	
	connect(): Observable<ParametrizarParametrosModel[]> {
		const displayDataChanges = [
			this._exampleDatabase.dataChange,
			this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: ParametrizarParametrosModel) => {
				let searchStr = (item.nanno).toString().toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect() {
	}
}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
@Component({
	selector: 'confirmacionDeleteParametro',
	templateUrl: 'confirmacionDeleteParametro.html',
})
export class DialogConfirmacion {

	constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/ParametrizarParametros/ParametrizarParametrosIndex.component.ts